import { Duration, addMinutes, differenceInCalendarDays, intervalToDuration, isBefore } from 'date-fns'
import { IChangeRouteServiceRouteForm } from 'features/Routes/components/EditRoute/RouteForm/types'
import { isNumber, max, trim } from 'lodash'

const COOLING_DOWN_MINUTES = 5
const MAX_ACTIVE_PERIOD_BEFORE_COOLING_DOWN = 7

export const isEditPlanningCoolingDown = (priceCheckedDate: Date | undefined, activePeriod: number): boolean => {
  if (!priceCheckedDate) return false

  return (
    activePeriod > MAX_ACTIVE_PERIOD_BEFORE_COOLING_DOWN &&
    isBefore(new Date(), addMinutes(priceCheckedDate, COOLING_DOWN_MINUTES))
  )
}

export const getRemaingSecondsBeforeEditing = (priceCheckedDate: Date | undefined): Duration => {
  if (!priceCheckedDate) {
    return {
      seconds: 0,
      minutes: 0
    }
  }

  return intervalToDuration({
    start: new Date(),
    end: addMinutes(priceCheckedDate, COOLING_DOWN_MINUTES)
  })
}

export const normalizeServiceCode = (code: string | undefined): string => {
  return trim(code).toLowerCase()
}

export const getActivePeriod = ({
  activePeriod,
  startDate,
  endDate
}: {
  activePeriod?: number | null
  startDate: Date
  endDate?: Date | null
}): number => {
  if (isNumber(activePeriod)) {
    return activePeriod
  }
  if (!endDate) {
    throw new Error('endDate is required if active period is not provided')
  }
  return differenceInCalendarDays(endDate, startDate) + 1
}

export const getMaxActivePeriod = (services: IChangeRouteServiceRouteForm[]): number => {
  return services.reduce((result: number, service: IChangeRouteServiceRouteForm): number => {
    return max([
      result,
      getActivePeriod({
        activePeriod: service.activePeriod,
        startDate: new Date(service.startAt),
        endDate: service.endAt ? new Date(service.endAt) : undefined
      })
    ]) as number
  }, 0)
}
